import { styled, useTheme } from '@mui/material';
import logoImageDark from 'assets/images/start/logo_dark.png';
import logoImageLight from 'assets/images/start/logo_light.png';
const AnotherClassLogoImage = styled('img')(
  `
    width: 150px;
    margin-right: 32px;
  `,
);

export default function NavbarLogo() {
  const theme = useTheme();
  const logoSrc = theme.palette.mode === 'dark' ? logoImageDark : logoImageLight;

  return <AnotherClassLogoImage src={logoSrc} alt="AnotherClass" />;
}
